export const PANE_EXISTSTREE = 'PANE_EXISTSTREE';
export const PANE_IMPORTTREE = 'PANE_IMPORTTREE';
export const PANE_INVALIDTREE = 'PANE_INVALIDTREE';
export const PANE_PROPERTIES = 'PANE_PROPERTIES';
export const PANE_SOURCETREE = 'PANE_SOURCETREE';
export const PANE_TARGETTREE = 'PANE_TARGETTREE';
